/**
 * Sign-up source ("where did this sign-up come from"), shared by the sign-up pages (client) and the
 * sign-up notification trigger + admin list (functions/src/signupNotifications.ts, via the generated
 * copy). A link like https://arevina.com/register/step1?src=omi tags every account created from it
 * with profiles/{uid}.signupSource = "omi".
 *
 * Rules:
 *   - no ?src= at all (or an empty one)       -> "direct"
 *   - lowercased, trimmed, only [a-z0-9_-], 1 to 40 characters -> kept as is
 *   - anything else (spaces, symbols, too long) -> "other"
 *
 * "other" rather than "direct" for a malformed tag: the visitor DID come from a tagged link, so
 * folding it into "direct" would undercount that campaign. "other" tells you a link carried a tag
 * that needs fixing, without ever storing arbitrary text a stranger typed into a URL.
 */

export const SIGNUP_SOURCE_DIRECT = 'direct';
export const SIGNUP_SOURCE_OTHER = 'other';
export const SIGNUP_SOURCE_MAX_LENGTH = 40;

const VALID_SOURCE = /^[a-z0-9_-]{1,40}$/;

/** Sanitizes a raw ?src= value. `null`/`undefined`/empty means no tag ("direct"). */
export function sanitizeSignupSource(raw: unknown): string {
  if (raw === null || raw === undefined) return SIGNUP_SOURCE_DIRECT;
  if (typeof raw !== 'string') return SIGNUP_SOURCE_OTHER;
  const value = raw.trim().toLowerCase();
  if (!value) return SIGNUP_SOURCE_DIRECT;
  return VALID_SOURCE.test(value) ? value : SIGNUP_SOURCE_OTHER;
}
